import { Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AddIcon from '@mui/icons-material/Add';
import { GridColumns } from '@mui/x-data-grid-premium';
import { EnhancedDataGrid } from 'components/common/enhanced/data-grid';
import TenantPage from 'components/common/TenantPage';
import { booleanCell } from 'components/common/enhanced/cells/boolean-cell';
import { labSubscriberService } from 'services/api';

export const LabSubscriberSettings = () => {
  const translationPrefix = 'pages.lab-subscriber-settings';
  const { t } = useTranslation();
  const columns: GridColumns = [
    {
      field: 'id',
      headerName: t('entities.lab-subscriber.id'),
      width: 90,
      renderCell: (params) => (
        <div>
          <Link to={`${params.row.id}`}>
            <b className="text-secondary-500">{params.value}</b>
          </Link>
        </div>
      )
    },
    {
      field: 'company_name',
      headerName: t('entities.lab-subscriber.company_name'),
      flex: 1,
      renderCell: (params) => params.value
    },
    {
      field: 'endpoint',
      headerName: t('entities.lab-subscriber.endpoints'),
      flex: 1,
      renderCell: (params) => params.value
    },
    {
      field: 'is_active',
      headerName: t('entities.lab-subscriber.is_active'),
      type: 'boolean',
      width: 120,
      editable: true,
      renderCell: booleanCell(t)
    }
  ];

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}
      menuRight={
        <Link to="new">
          <Button variant="outlined" size="small" startIcon={<AddIcon />}>
            {t(`${translationPrefix}.add`)}
          </Button>
        </Link>
      }>
      <div className="mt-6">
        <EnhancedDataGrid columns={columns} service={labSubscriberService} />
      </div>
    </TenantPage>
  );
};

export default LabSubscriberSettings;
